var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContactIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 499.788,
    height: 450.385,
    viewBox: "0 0 499.788 450.385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9842",
    "data-name": "Group 9842",
    transform: "translate(-1039.392 -153.615)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_419",
    "data-name": "Ellipse 419",
    transform: "translate(1081 165)",
    fill: "none",
    stroke: "#e6e7eb",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 219.5,
    cy: 219.5,
    r: 219.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 219.5,
    cy: 219.5,
    r: 217.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9843",
    "data-name": "Group 9843",
    transform: "translate(1517.88 375.116) rotate(-166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27748",
    "data-name": "Path 27748",
    d: "M2.339,54.465C10.086,20.831,36.62,0,36.62,0s13.974,33.7,6.228,67.336S8.567,121.8,8.567,121.8-5.407,88.1,2.339,54.465Z",
    transform: "translate(39.402 0)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27749",
    "data-name": "Path 27749",
    d: "M53.125,61.666C74.382,37.362,76.979,0,76.979,0S45.111,2.044,23.853,26.348,0,88.014,0,88.014,31.868,85.971,53.125,61.666Z",
    transform: "translate(0 0.026)",
    fill: "#a1a1b3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9844",
    "data-name": "Group 9844",
    transform: "translate(1049.735 437.77) rotate(-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27748-2",
    "data-name": "Path 27748",
    d: "M2.339,74.1c7.747,37.014,34.281,59.939,34.281,59.939s13.974-37.088,6.228-74.1S8.567,0,8.567,0-5.407,37.088,2.339,74.1Z",
    transform: "translate(75.085 0)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27749-2",
    "data-name": "Path 27749",
    d: "M77.751,26.348c31.11,24.3,34.91,61.666,34.91,61.666S66.021,85.971,34.91,61.666,0,0,0,0,46.64,2.044,77.751,26.348Z",
    transform: "translate(0 46)",
    fill: "#a1a1b3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9839",
    "data-name": "Group 9839",
    transform: "translate(1304.136 153.615)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_420",
    "data-name": "Ellipse 420",
    cx: 52.949,
    cy: 52.949,
    rx: 52.949,
    ry: 52.949,
    transform: "translate(0)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28500",
    "data-name": "Path 28500",
    d: "M685.539,282.769V402.835a9.467,9.467,0,0,1-9.37,9.468.837.837,0,0,1-.1,0H662.093a42.158,42.158,0,0,1-42.158-42.158V282.769a9.472,9.472,0,0,1,9.472-9.472h5.662c-2.623,7.652,32.979,10.874,34.934,0h6.064A9.472,9.472,0,0,1,685.539,282.769Z",
    transform: "translate(-537.074 -224.047)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28501",
    "data-name": "Path 28501",
    d: "M643.182,264.7a1.243,1.243,0,0,1,1.241-1.241h8.441a1.241,1.241,0,1,1,0,2.483h-8.441a1.243,1.243,0,0,1-1.242-1.241Z",
    transform: "translate(-536.186 -224.423)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28502",
    "data-name": "Path 28502",
    d: "M679.378,428.1H626a15.639,15.639,0,0,1-15.621-15.621V328.545a2.27,2.27,0,0,1-.946-1.847v-8.441a2.269,2.269,0,0,1,.946-1.846v-2.266a2.269,2.269,0,0,1-.946-1.846v-8.442a2.269,2.269,0,0,1,.946-1.846v-4.095a2.267,2.267,0,0,1-1.194-2v-8.441a2.268,2.268,0,0,1,1.194-2v-11.22A15.639,15.639,0,0,1,626,258.628h53.381A15.638,15.638,0,0,1,695,274.249v24.456a1.958,1.958,0,0,1,.92,1.659v16.1a1.959,1.959,0,0,1-.92,1.66v94.356A15.639,15.639,0,0,1,679.378,428.1ZM626,260.7a13.56,13.56,0,0,0-13.545,13.544v12.986l-1,.038a.2.2,0,0,0-.2.2v8.441a.2.2,0,0,0,.2.2l1,.038v7.319l-.79.195a.2.2,0,0,0-.156.194V312.3a.2.2,0,0,0,.156.194l.79.195v5.181l-.79.195a.2.2,0,0,0-.156.194V326.7a.2.2,0,0,0,.156.194l.79.195v85.389A13.56,13.56,0,0,0,626,426.02h53.381a13.56,13.56,0,0,0,13.544-13.544V316.342h.919V300.483h-.919V274.249A13.56,13.56,0,0,0,679.378,260.7Z",
    transform: "translate(-537.485 -224.607)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_422",
    "data-name": "Ellipse 422",
    cx: 1.241,
    cy: 1.241,
    rx: 1.241,
    ry: 1.241,
    transform: "translate(120.154 39.032)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_424",
    "data-name": "Ellipse 424",
    cx: 8.85,
    cy: 8.85,
    r: 8.85,
    transform: "translate(107.154 156.726)",
    fill: "#f5f5f5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9840",
    "data-name": "Group 9840",
    transform: "translate(1317.228 395.008)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_421",
    "data-name": "Ellipse 421",
    cx: 52.949,
    cy: 52.949,
    rx: 52.949,
    ry: 52.949,
    transform: "translate(96.96 60.85)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28507",
    "data-name": "Path 28507",
    d: "M976.082,509.97l-23.64-23.339a12.338,12.338,0,0,0-8.752-3.592h-.083a12.37,12.37,0,0,0-8.783,3.7,29.061,29.061,0,0,0-.509,40.324c.249.27.509.53.768.789a28.3,28.3,0,0,0,4.734,3.789,28.735,28.735,0,0,0,15.688,4.6h.176a28.89,28.89,0,0,0,20.5-8.638,12.482,12.482,0,0,0-.1-17.629Zm-1.37,16.165a27.089,27.089,0,0,1-34.012,3.613,27.823,27.823,0,0,1-4.163-3.374A27,27,0,0,1,936.3,488.2a10.292,10.292,0,0,1,7.33-3.083h.062a10.29,10.29,0,0,1,7.288,2.99l23.64,23.349a10.39,10.39,0,0,1,.094,14.68Z",
    transform: "translate(-848.879 -406.429)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28508",
    "data-name": "Path 28508",
    d: "M901.372,436.191l-23.64-23.349a12.382,12.382,0,0,0-8.752-3.592h-.073a12.4,12.4,0,0,0-8.794,3.706,29.15,29.15,0,0,0-4.9,34.261l.01.01a28.609,28.609,0,0,0,4.5,6.157c.2.228.426.457.654.685a28.9,28.9,0,0,0,20.422,8.389h.187a28.919,28.919,0,0,0,20.5-8.648A12.458,12.458,0,0,0,901.372,436.191ZM900,452.356a26.844,26.844,0,0,1-19.031,8.025h-.176a26.994,26.994,0,0,1-19.2-45.962,10.39,10.39,0,0,1,14.68-.093l23.64,23.339A10.4,10.4,0,0,1,900,452.356Z",
    transform: "translate(-851.733 -409.249)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28509",
    "data-name": "Path 28509",
    d: "M977.383,517.09,951.32,491.349a9.06,9.06,0,0,0-12.8.079,22.841,22.841,0,1,0,32.5,32.1Z",
    transform: "translate(-848.668 -406.211)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28510",
    "data-name": "Path 28510",
    d: "M902.677,443.306l-26.062-25.741a9.06,9.06,0,0,0-12.8.079,22.841,22.841,0,1,0,32.5,32.1Z",
    transform: "translate(-851.523 -409.031)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28511",
    "data-name": "Path 28511",
    d: "M951.759,535.017l-.623,1.64q-4.392-1.666-8.513-3.343c-48.671-19.861-71.907-43.107-87.449-87.231l-.01-.01q-1.106-3.115-2.149-6.375l1.64-.529a26.521,26.521,0,0,0,2.388,6q1.277,3.629,2.627,7.07c14.608,37.241,36.151,58.524,77.451,76.5q3.115,1.355,6.385,2.689A27.087,27.087,0,0,0,951.759,535.017Z",
    transform: "translate(-851.684 -408.105)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5397",
    "data-name": "Rectangle 5397",
    width: 2.077,
    height: 75.79,
    transform: "translate(24.107 52.796) rotate(-45.355)",
    fill: "#a1a1b3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9841",
    "data-name": "Group 9841",
    transform: "translate(1039.392 160.433)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28490",
    "data-name": "Path 28490",
    d: "M434.6,374.434c-2.593-2.488-5.246-16.364-8.557-17.773,2.475,5.47.678,6.918.665,12.921a40.615,40.615,0,0,1-1.185,10.117H369.435V335.927a29.949,29.949,0,0,1,29.951-29.95,17.872,17.872,0,0,1,4.438.65,28.477,28.477,0,0,1,20.09,20.145C428.19,342.4,434.991,368.417,434.6,374.434Z",
    transform: "translate(-209.227 -305.977)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28491",
    "data-name": "Path 28491",
    d: "M373.448,425.037l.028-34.119-20.056,1.792L360.5,414.23l-3.313,54.087a8.485,8.485,0,1,0,10.268,7.152Z",
    transform: "translate(-209.948 -302.731)",
    fill: "#facca8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28492",
    "data-name": "Path 28492",
    d: "M257.746,433.91h8.1l3.855-31.252H257.744Z",
    transform: "translate(-54.778 -67.792)",
    fill: "#facca8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28494",
    "data-name": "Path 28494",
    d: "M212.62,433.91h8.1l3.854-31.252H212.619Z",
    transform: "translate(-56.503 -67.792)",
    fill: "#facca8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28493",
    "data-name": "Path 28493",
    d: "M432.889,654.8l-12.809-.764v5.488L407.9,667.93a3.428,3.428,0,0,0,1.948,6.248H425.1l2.628-5.428,1.026,5.428h5.75Z",
    transform: "translate(-267.029 -292.676)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28496",
    "data-name": "Path 28496",
    d: "M405.671,355.43l-16.785.329-11.848,12.507-9.5,1.393A18.964,18.964,0,0,0,351.366,387.2h0l1.646,9.039h9.874l5.712,33.537c-2.221,5.659-2.372,10.127,2.187,11.881l14.152,26.659,41.8-18.76c2.12-3.644,2.8-7.3.632-10.864l2.988-51.34H440.4c0-9.6-3.248-17.7-12.79-18.766a112.792,112.792,0,0,0-11.409-.652Z",
    transform: "translate(-209.918 -304.087)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28495",
    "data-name": "Path 28495",
    d: "M387.764,654.8l-12.809-.764v5.488l-12.178,8.41a3.428,3.428,0,0,0,1.948,6.248h15.249l2.628-5.428,1.026,5.428h5.75Z",
    transform: "translate(-175.053 -292.676)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28497",
    "data-name": "Path 28497",
    d: "M426.95,446.385s-40.811,7.241-55.951-7.9c0,0-1.537,2.609-3.853,6.937-.666,1.244-1.952,2.088-2.729,3.6-.706,1.37-2.522,3.054-3.291,4.608-.619,1.25.374,2.884-.27,4.234-7.753,16.262-16.812,39.2-14.87,54.349,1.252,9.768,3.839,32.5,6.563,56.911.213,1.907-1.511,4.358-1.3,6.28.2,1.813,2.341,3.1,2.543,4.915.134,1.206-1.36,2.437-1.227,3.642.147,1.322,1.921,2.618,2.067,3.935,3.732,33.709,7.149,65.18,7.149,65.18h19.089l3.6-71.877-2.943-26.2,6.912-52.989,9.544,50.356,1.228,28.34L409.3,654.389H426.95V583.056l1.316-3.706L426.95,574.6l1.316-5.121L426.95,563.9Z",
    transform: "translate(-210.133 -300.913)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28498",
    "data-name": "Path 28498",
    d: "M409.894,347.176a19.026,19.026,0,1,1,3.3-15.9c.055.228.1.455.146.69A19,19,0,0,1,409.894,347.176Z",
    transform: "translate(-208.989 -305.567)",
    fill: "#facca8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28499",
    "data-name": "Path 28499",
    d: "M405.947,336.367a10,10,0,0,0-2.923-5.3,13.643,13.643,0,0,1-.79,5.72,26.366,26.366,0,0,1-14.488-2.87c-3.357-2.277-7.629-2.08-12.605,0a18.429,18.429,0,0,1,18.433-18.431h3.289a18.433,18.433,0,0,1,18.431,18.427A54.882,54.882,0,0,1,405.947,336.367Z",
    transform: "translate(-209.009 -305.614)",
    fill: "#1d1d26"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_419-2",
    "data-name": "Ellipse 419",
    cx: 52.949,
    cy: 52.949,
    rx: 52.949,
    ry: 52.949,
    transform: "translate(0 159.763)",
    fill: "#e6e7eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28503",
    "data-name": "Path 28503",
    d: "M402.342,499.3h-138.9A7.463,7.463,0,0,1,256,491.858v-67.68a7.463,7.463,0,0,1,7.443-7.444h138.9a7.463,7.463,0,0,1,7.444,7.443v67.68a7.463,7.463,0,0,1-7.443,7.444Z",
    transform: "translate(-213.562 -301.745)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28504",
    "data-name": "Path 28504",
    d: "M402.342,499.3h-138.9A7.463,7.463,0,0,1,256,491.858v-67.68a7.463,7.463,0,0,1,7.443-7.444h138.9a7.463,7.463,0,0,1,7.444,7.443v67.68a7.463,7.463,0,0,1-7.443,7.444Zm-138.9-80.491a5.383,5.383,0,0,0-5.368,5.368v67.678a5.383,5.383,0,0,0,5.369,5.367h138.9a5.383,5.383,0,0,0,5.368-5.368V424.178a5.383,5.383,0,0,0-5.368-5.367Z",
    transform: "translate(-213.562 -301.745)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28505",
    "data-name": "Path 28505",
    d: "M339.878,488.973c-27.394,0-55.959-.262-66.616-.431A5.374,5.374,0,0,1,268,483.189V427.165a1.9,1.9,0,0,1,1.893-1.9h125.08a1.9,1.9,0,0,1,1.9,1.892v38.011a23.715,23.715,0,0,1-23.315,23.622C363.62,488.922,351.858,488.973,339.878,488.973Z",
    transform: "translate(-213.103 -301.419)",
    fill: "#991f1f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28506",
    "data-name": "Path 28506",
    d: "M387.946,462.005H274.926a4.608,4.608,0,0,1-4.323-3.048L257.811,423.07a4.592,4.592,0,0,1,4.317-6.132l141.272-.2a4.592,4.592,0,0,1,4.526,5.4l.109.046-.406.946,0,.01-15.464,36.084a4.578,4.578,0,0,1-4.215,2.782Zm15.461-43.188-141.275.2a2.515,2.515,0,0,0-2.365,3.359l12.792,35.886a2.527,2.527,0,0,0,2.369,1.67H387.946a2.505,2.505,0,0,0,2.307-1.523l15.465-36.085.76.326-.76-.326a2.514,2.514,0,0,0-2.311-3.5Z",
    transform: "translate(-213.503 -301.744)",
    fill: "#a1a1b3"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_423",
    "data-name": "Ellipse 423",
    cx: 8.85,
    cy: 8.85,
    r: 8.85,
    transform: "translate(110.269 150.374)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28512",
    "data-name": "Path 28512",
    d: "M438.307,417.429l.028-34.119L418.278,385.1l7.078,21.518-25.693,38.948a8.485,8.485,0,1,0,10.268,7.152Z",
    transform: "translate(-208.325 -303.022)",
    fill: "#facca8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/ContactIcon.92cf578f8e59103c639b59f99226208f.svg";
export { ForwardRef as ReactComponent };